import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItemAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { IOrcamento } from "app/types/IOrcamento"
import {CriaOrcamentoAposTotalizador} from "../../utils/CriaOrcamentoAposTotalizador";



declare var window:any

export type definirValorSeguroEntregaTotalizadorInput = {
    valorSeguroEntrega: number
}

export async function definirValorSeguroEntregaTotalizador(input: definirValorSeguroEntregaTotalizadorInput) {

    const orcamentoAtualizado = await microuniversoApi.Orcamento.DefinirValorSeguroEntrega(
        store.getState().orcamento.IdentificadorOrcamento,
        input.valorSeguroEntrega
    )

    const atualizarOrcamentoLegadoERedux = () => {
        const orcamentoLegado = window.orcamentoController.model
        const orcamentoAtual = store.getState().orcamento
        const novosOrcamentos = CriaOrcamentoAposTotalizador(orcamentoAtual, orcamentoLegado, orcamentoAtualizado)

        orcamentoLegado.atualizar(novosOrcamentos.orcamentoLegado)

        store.dispatch(sobrescreverInformacoesAction(novosOrcamentos.orcamentoReact))

    }


    atualizarOrcamentoLegadoERedux()
}
